export default __webpack_public_path__ + "img/pin_icons/ventilator_w.svg";